'use strict';

/**
 * Checks if the current page is in Page Designer edit mode
 * @function
 * @returns {boolean} True if in Page Designer edit mode, false otherwise
 */
function isPageDesignerEditMode() {
    return window.location.href.indexOf('__SYSTEM__Page-Show') > 0;
}

module.exports = {
    isPageDesignerEditMode: isPageDesignerEditMode
};